export const userMultiCenter = false;
export const userAddEditMode = false;